import { get } from "lodash"
import PropTypes from "prop-types"
import React from "react"
import { Link, withRouter } from "react-router-dom"
import { compose, lifecycle, withHandlers, withState } from "recompose"
import { Breadcrumb, Container, Divider, Header, Loader, Segment, Sidebar } from "semantic-ui-react"
import { NotificationsList, VersionsTable } from "./components"
import { CaseStatusesApiService } from "./../../api"

const CaseStatusHistory = ({
	onHideSidebarSuccess,
	onSelectVersion,
	isLoading,
	isSidebarVisible,
	selectedVersion,
	title,
	versions
}) => (
	<Container>
		<Breadcrumb>
			<Breadcrumb.Section as={Link} to="/">
				Strona główna
			</Breadcrumb.Section>
			<Breadcrumb.Divider icon="right angle" />
			<Breadcrumb.Section as={Link} to="/historia-statusow-spraw">
				Historia statusów spraw
			</Breadcrumb.Section>
			<Breadcrumb.Divider icon="right angle" />
			<Breadcrumb.Section active>{title}</Breadcrumb.Section>
		</Breadcrumb>
		{isLoading ? (
			<Loader active={true} content="Ładowanie historii statusu..." inline="centered" />
		) : (
			<VersionsTable
				onSelect={onSelectVersion}
				selectedVersion={selectedVersion}
				versions={versions}
			/>
		)}
		<Sidebar
			animation="overlay"
			as={Segment}
			direction="right"
			onHidden={onHideSidebarSuccess}
			visible={isSidebarVisible}
			width="wide">
			<Header as="h3">Notyfikacje</Header>
			<Divider />
			<NotificationsList notifications={get(selectedVersion, "notifications")} />
		</Sidebar>
	</Container>
)

CaseStatusHistory.propTypes = {
	onHideSidebarSuccess: PropTypes.func.isRequired,
	onSelectVersion: PropTypes.func.isRequired,
	isSidebarVisible: PropTypes.bool,
	selectedVersion: PropTypes.object,
	title: PropTypes.string,
	versions: PropTypes.array
}

CaseStatusHistory.defaultProps = {
	versions: []
}

const enhance = compose(
	withRouter,
	withState("title", "setTitle", "..."),
	withState("isLoading", "setLoading", false),
	withState("isSidebarVisible", "setSidebarVisible", false),
	withState("selectedVersion", "setSelectedVersion", null),
	withState("versions", "setVersions"),
	withHandlers({
		onHideSidebarSuccess: ({ setSelectedVersion }) => () => setSelectedVersion(null),
		onSelectVersion: ({ selectedVersion, setSelectedVersion, setSidebarVisible }) => (
			event,
			version
		) => {
			setSelectedVersion(version)
			const showSidebar =
				get(selectedVersion, "caseStatusVersionId") !== get(version, "caseStatusVersionId")
			setSidebarVisible(showSidebar)
		}
	}),
	lifecycle({
		async componentDidMount() {
			this.props.setLoading(true)
			try {
				const caseStatusId = get(this.props, "match.params.caseStatusId")
				const {
					caseStatusId: title,
					versions
				} = await CaseStatusesApiService.getCaseStatus(caseStatusId)
				this.props.setTitle(`${title}`)
				this.props.setVersions(versions)
			} finally {
				this.props.setLoading(false)
			}
		}
	})
)

export default enhance(CaseStatusHistory)



// WEBPACK FOOTER //
// ./src/containers/case-status-history/CaseStatusHistory.js